import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  isCustomFieldsFeatureEnabledSelector,
  isOrganizationMultiLocationTieringEnabledSelector,
} from 'store/selectors/featureFlagSelectors';

export const OrganizationSettingsRedirectPage: FC = () => {
  const isOrganizationMultiLocationTieringEnabled = useSelector(
    isOrganizationMultiLocationTieringEnabledSelector,
  );
  const isCustomFieldsFeatureEnabled = useSelector(isCustomFieldsFeatureEnabledSelector);
  if (isOrganizationMultiLocationTieringEnabled) {
    return <Redirect to={`/settings/organization/seniority-ranking`} />;
  }
  if (isCustomFieldsFeatureEnabled) {
    return <Redirect to="/settings/organization/custom-fields" />;
  }
  return <Redirect to="/settings/organization/general-settings" />;
};
